import isEmpty from 'lodash.isempty';
import { INTERP } from './CommonConstants';

export const PROFICIENT_LEVEL = {
    FAR_BELOW_PROFICIENT: 'far below proficient',
    WELL_BELOW_PROFICIENT: 'well below proficient',
    BELOW_PROFICIENT: 'below proficient',
    PROFICIENT: 'proficient',
    ABOVE_PROFICIENT: 'above proficient',
};

export const TRC_INTERP_MAPPER = {
    [PROFICIENT_LEVEL.FAR_BELOW_PROFICIENT]: INTERP.RED,
    [PROFICIENT_LEVEL.WELL_BELOW_PROFICIENT]: INTERP.RED,
    [PROFICIENT_LEVEL.BELOW_PROFICIENT]: INTERP.YELLOW,
    [PROFICIENT_LEVEL.PROFICIENT]: INTERP.GREEN,
    [PROFICIENT_LEVEL.ABOVE_PROFICIENT]: INTERP.BLUE,
};

export const getTrcInterpretation = interp =>
    isEmpty(interp) ? null : TRC_INTERP_MAPPER[interp.toLowerCase()];
